import { type Nil } from "@mcwd/typescript-type-guards";
import type { LinkDownloadType } from "assets/mcui-js/tracking/LinkDownloadType.js";
import { EmptyElement, ImageElement, ButtonElement, LinkElement } from "./CtaElementData.js";


export class CtaFactory {
  static createCtaClass(element: JQuery<HTMLElement> | Nil, ctaType: LinkDownloadType | Nil) {

    if (!element) {
      return new EmptyElement("CTA Element not set in tracking data.");
    }

    if (!ctaType) {
      return new EmptyElement("CTA Type not set in tracking data.");
    }

    switch (ctaType) {
      case "image":
        return new ImageElement(element);
      case "button":
        return new ButtonElement(element);
      case "text":
        return new LinkElement(element);
      default:
        throw new Error(`Unsupported CTA type: ${ctaType as string}`);
    }
  }
}
